import core from '@bmp-vue/core'
import modules from '@/plugins/store/modules'

core.extendRouterBeforeEach = function (vm) {
  return (vm.$user && vm.$empresa.isAutentication)
}

core.extendEmpresa = function (data, callback) {
  callback(data)
}
core.viewsProps = {
  Login: {
    redirect_url: '/loginafter',
    loginField: 'username'
  },
  Lembrar: {
    loginField: 'username'
  }
}

const controllers = require.context(
  '@/controllers', true, /\.js$/
)
core.methods.init(controllers)
modules.forEach(p => {
  core.store.registerModule(p.name, p)
})

function isApiLoaded () {
  setTimeout(function () {
    if (core.store.getters.loading || core.store.getters.activeRequests > 0) {
      isApiLoaded()
      return false
    }

    require('@/components/')

    const theme = require('theme').default

    const paths = require('@/plugins/router/paths').default
    const App = () => import('./App')
    core.methods.finish(paths, theme, App)
  }, 100)
}

isApiLoaded()
